module.exports = __webpack_public_path__ + "static/media/D9D29AB0-617E-4CA5-BA6D-868D172D23C2.b6a15d92.png";